<p>project-settings works!</p>
